import styles from './timeBlock.module.css';
import parseISO from 'date-fns/parseISO';
import format from 'date-fns/format';
import { FunctionComponent } from 'react';
import { Text } from 'components/text';

export const TimeBlock: FunctionComponent<{
    to: string;
    noTime?: boolean;
}> = ({ to: toRaw, noTime }) => {
    const to = parseISO(toRaw);

    return (
        <div className={styles.timeBlock}>
            <div className={styles.timeBlock__separator}>
                <Text k={'Order until'} />:
            </div>
            <div className={styles.timeBlock__block}>
                {!noTime ? (
                    <div className={styles.timeBlock__time}>
                        {format(to, 'HH:mm')}
                    </div>
                ) : (
                    ''
                )}
                <div className={styles.timeBlock__date}>
                    {format(to, 'dd.LL.yyyy')}
                </div>
            </div>
        </div>
    );
};
